module.exports = __webpack_public_path__ + "img/COFI.d0a8c8b4.svg";